import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CancelScheduleSendIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cancel_schedule_send"}/>
}
